import { render, staticRenderFns } from "./CardProductsTable.vue?vue&type=template&id=801b9652"
import script from "./CardProductsTable.vue?vue&type=script&lang=js"
export * from "./CardProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports